<template>
  <div class="flexbox full-expand">
    <div class="header">
      <div class="flexbox header-content">
        <div class="logo-container">
          <router-link to="/" exact>
          <img alt="Nrs Conferencing Logo" src="@/assets/images/NRS_Logo_White_New.svg" >
          </router-link>  
        </div>
      </div>
    </div>
    
    <div class="flexbox header-content visible-height global-dial-in-numbers">
      <div class="heading" >{{title}}</div>
        <slot></slot>
        <Footer></Footer>
    </div> 
  </div>
</template>

<script setup>
import Footer from '@/components/common/Footer/FooterConnectfn.vue';

// Import composables
import { useGlobal } from '@/composables/';

// Define component name
defineOptions({
  name: "admin-app-container"
});

// Using composables
const { pageTitle: title } = useGlobal();
</script>
<style lang="stylus" scoped>
 .visible-height {
    min-height: calc(100% - 180px);
 }
 .global-dial-in-numbers {
  padding: 30px 1% 0 1%;
  box-sizing: border-box;
  overflow: auto;
  @media (max-width: 767px) {
    padding 15px;
    width 100%;
  }
 }
 .full-expand {
   overflow-y :auto;
   overflow-x : hidden;
 }
 .flexbox {
    width: 100%;
    height: 100%;
    display: flex;
    line-height: 1;
    flex-direction: column;
    flex: 1;
 }
 .header-content {
  max-width: 996px;
  margin: 0 auto;
}
 .header {
    width: 100%;
    background: #305A7A;
    height: 70px;
    background-size: cover;
 }
 .logo-container {
    padding: 23px 15px 0 15px;
    width: 100%;
 }
 .heading {
    color: #305A7A;
    font-weight: bold;
    font-size: 1.5rem;
 }
</style>


